import { gql } from "@apollo/client";

export const FETCH_ALL_MULTISLOT_CONTENT_LIST = gql`
  query FETCH_ALL_MULTISLOT_CONTENT_LIST(
    $filter: String!
    $cdpFilter: [String]!
    $searchTerm: String!
    $pagination: authoring_Paginate!
    $tags: [String]!
    $isSuggestive: Boolean
  ) {
    authoring_getDynamicContentSearch(
      filter: $filter
      cdpFilter: $cdpFilter
      searchTerm: $searchTerm
      pagination: $pagination
      tags: $tags
      isSuggestive: $isSuggestive
    )
  }
`;

export const FETCH_ALL_MULTISLOT_CONTENT_LIST_WITH_SORT_FILTER = gql`
  query FETCH_ALL_MULTISLOT_CONTENT_LIST_WITH_SORT_FILTER(
    $filter: String!
    $cdpFilter: [String]!
    $searchTerm: String!
    $pagination: authoring_Paginate!
    $tags: [String]!
    $isSuggestive: Boolean
    $sortOptions: authoring_SortOptions
    $dateFilter: authoring_DateFilter
    $created_by: [String]
    $pageFilter: [authoring_PageFilter]
  ) {
    authoring_getDynamicContentSearch(
      filter: $filter
      cdpFilter: $cdpFilter
      searchTerm: $searchTerm
      pagination: $pagination
      tags: $tags
      isSuggestive: $isSuggestive
      sortOptions: $sortOptions
      dateFilter: $dateFilter
      created_by: $created_by
      pageFilter: $pageFilter
    )
  }
`;

/**
 * product get list
 */
export const FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST = gql`
  query FETCH_ALL_ECOM_PRODUCT_CONTENT_LIST(
    $filter: String!
    $searchTerm: String!
    $pagination: authoring_Paginate!
    $tags: [String]!
    $isSuggestive: Boolean
    $ecommerceRequest: authoring_ecommerceRequest!
  ) {
    authoring_getDynamicContentSearch(
      filter: $filter
      searchTerm: $searchTerm
      pagination: $pagination
      tags: $tags
      isSuggestive: $isSuggestive
      ecommerceRequest: $ecommerceRequest
    )
  }
`;

/**
 * filter get list
 */
export const FETCH_ALL_FILTER_PRODUCT_LIST = gql`
  query FETCH_ALL_FILTER_PRODUCT_LIST($filter: [String]!, $searchTerm: String!) {
    authoring_getEcommerceCategories(filter: $filter, searchTerm: $searchTerm)
  }
`;
